import { PERMISSIONS, terraContract } from '@terra/shared-authorization';
import { z } from 'zod';
import { FindingAttackPathDtoSchema } from './finding-attack-path.schema';

export const getFindingAttackPathContract = terraContract
  .meta({
    permissions: [PERMISSIONS.VIEW_FINDINGS.name],
  })
  .route({
    method: 'GET',
    path: '/id/{id}/attack-path',
    summary: 'Get finding attack path',
    description:
      'Returns the attack path from entry point through assets, weakness, and credentials to a web or external finding.',
    inputStructure: 'detailed',
  })
  .input(z.object({ params: z.object({ id: z.string() }) }))
  .output(FindingAttackPathDtoSchema);
